// extracted by mini-css-extract-plugin
export default {"ScenarioActionsMenu-menu":"ScenarioActionsMenu_ScenarioActionsMenu-menu__FDIJw"};